module.exports = __webpack_public_path__ + "static/scale-model-of-chudnow-museum-of-yesteryear-in-milwaukee-wisconsin-ec516724dce19e7069bc93c9b533fb08.png";